export enum ApplicationDocumentsTableSize {
  Name = 36,
  Type = 12,
  Size = 10,
  UpdatedAt = 21,
  CreatedAt = 21,
}
